module.exports = __webpack_public_path__ + "static/media/weapon.ed83f00a.svg";